import { TagListItem } from '@/models/dictionary/tag-list.model';
import { SegmentListItem } from '@/models/dictionary/segment-list.model';

export type PayoutOrderListFilter = {
  tagIdList?: string[];
  tagIdListCondition?: string;
  segmentIdList?: string[];
  segmentIdListCondition?: string;
  applicationStatus?: string;
  processingType?: string;
  playerEmail?: string;
  payoutStatus?: string;
  countryList?: string[];
  countryListCondition?: string;
  paymentSystemList?: string[];
  paymentSystemListCondition?: string;
}

export enum PayoutOrderListFilterProperties {
  SEGMENT_ID_LIST_CONDITION = 'segmentIdListCondition',
  TAG_ID_LIST_CONDITION = 'tagIdListCondition',
  PAYMENT_SYSTEM_LIST_CONDITION = 'paymentSystemListCondition',
  COUNTRY_LIST_CONDITION = 'countryListCondition',
}

export type PayoutOrderListFilterFormData = {
  tagList: TagListItem[];
  tagIdListCondition: string;
  segmentList: SegmentListItem[];
  segmentIdListCondition: string;
  applicationStatus: string;
  processingType: string;
  playerEmail: string;
  payoutStatus: string;
  countryList: string[];
  countryListCondition: string;
  paymentSystemList: string[];
  paymentSystemListCondition: string;
}
